module.exports = __webpack_public_path__ + "static/img/wechat-2.a26f39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/wechat-2.png
// module id = L3EY
// module chunks = 215